export default "__VITE_ASSET__c6569600__"